import moment from "moment";
import store from "../../../../store";
import Flowit from "../../../../services/flowit";
import { state } from "./mutations";
import * as types from "./types";

export const getWallet = ({ commit }) => {
  Flowit.wallet.getWallet().then(response => {
    commit(types.SET_WALLET_DATA, response.data);
  });
};

export const getExtract = ({ commit }, params) => {
  commit(types.LOADING_DATA, true);
  commit(types.SET_ALL, []);
  commit(types.SET_RECEIVEDS, []);
  commit(types.SET_SENDEDS, []);

  // Usar params se fornecidos, senão usar state.filterParams
  const extractParams = params || state.filterParams;

  Flowit.wallet
    .getExtract(extractParams)
    .then(response => {
      commit(types.TOTAL_RESOURCES, response.data.resources);
      commit(types.SET_ALL, response.data.all.transactions);
      commit(types.SET_RECEIVEDS, response.data.received.transactions);
      commit(types.RECEIVEDS_TOTAL, response.data.received.count);
      commit(types.SET_SENDEDS, response.data.sended.transactions);
      commit(types.SENDEDS_TOTAL, response.data.sended.count);
      commit(types.PAGE, response.data.page);
      commit(types.LIMIT, response.data.limit);
      commit(types.LOADING_DATA, false);
    })
    .catch(error => {
      commit(types.LOADING_DATA, false);
    });
};

// eslint-disable-next-line no-unused-vars
export const exportWallet = ({ commit }, params) => {
  commit(types.LOADING_DATA, true);
  Flowit.wallet.exportWallet(params).then(response => {
    // Don't automatically redirect anymore - let the component handle the response
    commit(types.LOADING_DATA, false);
  }).catch(error => {
    commit(types.LOADING_DATA, false);
  });
};

export const checkWalletExportStatus = ({ commit }) => {
  return Flowit.wallet.checkWalletExportStatus();
};

export const downloadWalletExport = ({ commit }, params) => {
  return Flowit.wallet.downloadWalletExport(params).then(response => {
    if (response.data.download_url) {
      // Create a temporary link and click it to download
      const link = document.createElement('a');
      link.href = response.data.download_url;
      link.download = params.file_name || 'wallet_extract.xlsx';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
    return response;
  });
};

export const updateOrdination = ({ commit }, newOrdination) => {
  commit(types.ORDINATION, newOrdination);
};

export const setLoadingData = ({ commit }, status) => {
  commit(types.LOADING_DATA, status);
};

export const kind = ({ commit }, param) => {
  commit(types.KIND, param);
};

export const setWalletData = ({ commit }, data) => {
  commit(types.SET_WALLET_DATA, data);
};
export const setLimit = ({ commit }, param) => {
  commit(types.LIMIT, param);
  // Atualizar filterParams com o novo limit e resetar página
  const newFilterParams = {
    ...state.filterParams,
    limit: param,
    page: 1
  };
  commit(types.FILTER_PARAMS, newFilterParams);
};
export const setCurrentPage = ({ commit }, param) => {
  commit(types.PAGE, param);
  // Atualizar filterParams com a nova página
  const newFilterParams = {
    ...state.filterParams,
    page: param
  };
  commit(types.FILTER_PARAMS, newFilterParams);
};

export const withdrawRequest = ({ commit, dispatch }, params) => {
  commit(types.LOADING_DATA, true);
  
  // Resetar estados anteriores
  commit(types.WITHDRAW_SUCCESS, false);
  commit(types.WITHDRAW_ERROR, false);
  commit(types.WITHDRAW_ERROR_MESSAGE, '');
  
  Flowit.wallet
    .withdrawRequest(params)
    .then(response => {
      commit(types.WITHDRAW_SUCCESS, true);
      commit(types.WITHDRAW, response.data.withdraw);
      commit(types.NOTIFICATION_BAR, true);
      commit(types.LOADING_DATA, false);
      
      // Atualizar saldo da carteira imediatamente após saque bem-sucedido
      dispatch('getWallet');
      // Opcional: também atualizar o extrato
      dispatch('getExtract');
    })
    .catch(error => {
      commit(types.WITHDRAW_ERROR_MESSAGE, error.response.data.error || 'Erro interno do sistema');
      commit(types.WITHDRAW_ERROR, true);
      commit(types.NOTIFICATION_BAR, true);
      commit(types.LOADING_DATA, false);
    });
};

export const showFilters = ({ commit }, param) => {
  commit(types.SHOW_FILTERS, param);
};

export const setStartAt = ({ commit }, param) => {
  const newFilterParams = { 
    ...state.filterParams,
    filterrific: {
      ...state.filterParams.filterrific,
      with_created_at_between: {
        ...state.filterParams.filterrific.with_created_at_between,
        start_at: param
      }
    }
  };
  commit(types.FILTER_PARAMS, newFilterParams);
};

export const updateStartAt = ({ commit }, param) => {
  const newFilterParams = { 
    ...state.filterParams,
    filterrific: {
      ...state.filterParams.filterrific,
      with_created_at_between: {
        ...state.filterParams.filterrific.with_created_at_between,
        start_at: param
      }
    }
  };
  commit(types.FILTER_PARAMS, newFilterParams);
};

export const updateEndAt = ({ commit }, param) => {
  const newFilterParams = { 
    ...state.filterParams,
    filterrific: {
      ...state.filterParams.filterrific,
      with_created_at_between: {
        ...state.filterParams.filterrific.with_created_at_between,
        end_at: param
      }
    }
  };
  commit(types.FILTER_PARAMS, newFilterParams);
};

export const setFilterParams = ({ commit }, params) => {
  commit(types.FILTER_PARAMS, params);
};
// filters

export const resetFilters = ({ commit }) => {
  commit(
    types.SET_FILTER_INITIAL_DATE,
    moment()
      .startOf("month")
      .format("YYYY-MM-DD")
  );
  commit(
    types.SET_FILTER_FINAL_DATE,
    moment()
      .endOf("month")
      .format("YYYY-MM-DD")
  );
  commit(types.SET_FILTER_ORDINATION, "");
  commit(types.KIND, "");
  commit(types.ORDINATION, null);
  commit(
    types.FILTER_INITIAL_DATE,
    moment()
      .startOf("month")
      .format("YYYY-MM-DD")
  );
  commit(
    types.FILTER_FINAL_DATE,
    moment()
      .endOf("month")
      .format("YYYY-MM-DD")
  );
};
